import { render, staticRenderFns } from "./lvdai.vue?vue&type=template&id=36637a8c&scoped=true"
import script from "./lvdai.vue?vue&type=script&lang=js"
export * from "./lvdai.vue?vue&type=script&lang=js"
import style0 from "./lvdai.vue?vue&type=style&index=0&id=36637a8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36637a8c",
  null
  
)

export default component.exports